(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eyre-cine-look-lab"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eyre-cine-look-lab')) {
    customElements.define('eyre-cine-look-lab', class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        this.ready=true; this.state={shot:0,look:'everyday_1',film:false,gate:'none'};
        this.renderMap=this.querySelector('[data-render-map]') ? JSON.parse(this.querySelector('[data-render-map]').textContent) : null;
        this.renderCache=new Map(); this.renderRequest=0;
        this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
        this.addEventListener('click',event=>{
          const button=event.target.closest('button');if(!button||!this.contains(button))return;
          if(button.hasAttribute('data-expand')){this.expand();return;}
          if(button.hasAttribute('data-close')){this.collapse();return;}
          if(button.hasAttribute('data-shot')){this.state.shot=Number(button.dataset.shot);}
          if(button.hasAttribute('data-look'))this.state.look=button.dataset.look;
          if(button.hasAttribute('data-film'))this.state.film=button.dataset.film==='on';
          if(button.hasAttribute('data-gate'))this.state.gate=button.dataset.gate;
          if(button.hasAttribute('data-reset'))this.state={shot:this.state.shot,look:'original',film:false,gate:'none'};
          this.update();
        }); this.update();
      }
      expand(){
        this.returnFocus=this.querySelector('[data-expand]');
        this.savedOverflow=document.body.style.overflow;
        this.anchor=document.createComment('eyre-look-position');this.before(this.anchor);
        document.body.append(this);document.body.style.overflow='hidden';
        this.classList.add('is-expanded');this.setAttribute('role','dialog');this.setAttribute('aria-modal','true');this.setAttribute('aria-label','See the film look in action');
        this.querySelector('[data-close]').hidden=false;this.querySelector('[data-expand]').hidden=true;
        this.onModalKey=event=>{
          if(event.key==='Escape'){event.preventDefault();this.collapse();}
          if(event.key==='Tab'){
            const buttons=[...this.querySelectorAll('button')].filter(b=>!b.hidden&&b.getClientRects().length);
            const first=buttons[0],last=buttons[buttons.length-1];
            if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
            else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
          }
        };
        this.addEventListener('keydown',this.onModalKey);this.querySelector('[data-close]').focus();
      }
      collapse(){
        this.classList.remove('is-expanded');this.removeAttribute('role');this.removeAttribute('aria-modal');this.removeAttribute('aria-label');
        this.querySelector('[data-close]').hidden=true;this.querySelector('[data-expand]').hidden=false;
        this.anchor.replaceWith(this);document.body.style.overflow=this.savedOverflow;
        this.removeEventListener('keydown',this.onModalKey);this.returnFocus.focus();
      }
      async updateRender(){
        const {shot,look,film,gate}=this.state;
        const key=[shot,look,film?'on':'off',gate].join('|');
        const url=this.renderMap[key];
        const request=++this.renderRequest;
        this.querySelectorAll('[data-shot]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.shot)===shot)));
        this.querySelectorAll('[data-look]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.look===look)));
        this.querySelectorAll('[data-film]').forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.film==='on')===film)));
        this.querySelectorAll('[data-gate]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gate===gate)));
        const label=this.querySelector('[data-look][aria-pressed=true]').textContent.trim();
        const description=label+' · Image '+(shot+1);
        const status=this.querySelector('[data-selection]');
        const img=this.querySelector('[data-look-render]');
        const frame=this.querySelector('.eyre-lab__frame');
        this.querySelector('.eyre-lab__notice').textContent='Compare Log with each of the eight Cine LUT looks.';
        if(!url){img.hidden=true;frame.setAttribute('aria-busy','false');status.textContent='This combination is not available yet.';return;}
        status.textContent='Loading '+description+'…';frame.setAttribute('aria-busy','true');img.hidden=true;
        try{
          if(!this.renderCache.has(url)){
            const pending=new Promise((resolve,reject)=>{const asset=new Image();asset.onload=()=>resolve(asset);asset.onerror=()=>reject(new Error('Image unavailable'));asset.src=url;});
            this.renderCache.set(url,pending);
          }
          await this.renderCache.get(url);
          if(request!==this.renderRequest)return;
          img.src=url;img.alt=description;img.hidden=false;frame.setAttribute('aria-busy','false');status.textContent=description;
        }catch(error){
          this.renderCache.delete(url);
          if(request!==this.renderRequest)return;
          img.hidden=true;frame.setAttribute('aria-busy','false');status.textContent='Image could not load. Select the look again to retry.';
        }
      }

      update(){
        if(this.renderMap){this.updateRender();return;}
        this.querySelectorAll('[data-shot-frame]').forEach(frame=>frame.hidden=this.state.gate!=='none'||Number(frame.dataset.shotFrame)!==this.state.shot);
        this.querySelectorAll('[data-shot]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.shot)===this.state.shot)));
        this.querySelectorAll('[data-look]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.look===this.state.look)));
        this.querySelectorAll('[data-film]').forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.film==='on')===this.state.film)));
        this.querySelectorAll('[data-gate]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.gate===this.state.gate)));
        this.querySelectorAll('[data-gate-image]').forEach(img=>img.hidden=img.dataset.gateImage!==this.state.gate);
        const selected=this.querySelector('[data-look][aria-pressed=true]');
        const labels=[selected?selected.textContent:this.copy.original];
        if(this.state.film)labels.push(this.copy.film);if(this.state.gate!=='none')labels.push(({curved:'35mm Curved',square:'35mm Square',super16:'Super 16'})[this.state.gate]);
        this.querySelector('[data-selection]').textContent=this.state.gate!=='none'?({curved:'35mm Curved',square:'35mm Square',super16:'Super 16'})[this.state.gate]+' · supplied gate sample':labels.join(' + ')+(this.state.look!=='original'||this.state.film?' · '+this.copy.pending:'');
        this.querySelector('.eyre-lab__notice').textContent=this.state.gate!=='none'?'Gate preview uses your supplied image. LUT and Film Look combinations are not shown yet.':'Design preview: LUT and Film Look exports are still needed. Gate buttons show the supplied gate samples.';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eyre-look-lab"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eyre-look-lab')) {
    customElements.define('eyre-look-lab', class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        this.ready=true; this.state={shot:0,look:'everyday_1',film:false,gate:'none'};
        this.renderMap=this.querySelector('[data-render-map]') ? JSON.parse(this.querySelector('[data-render-map]').textContent) : null;
        this.renderCache=new Map(); this.renderRequest=0;
        this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
        this.addEventListener('click',event=>{
          const button=event.target.closest('button');if(!button||!this.contains(button))return;
          if(button.hasAttribute('data-expand')){this.expand();return;}
          if(button.hasAttribute('data-close')){this.collapse();return;}
          if(button.hasAttribute('data-shot')){this.state.shot=Number(button.dataset.shot);}
          if(button.hasAttribute('data-look'))this.state.look=button.dataset.look;
          if(button.hasAttribute('data-film'))this.state.film=button.dataset.film==='on';
          if(button.hasAttribute('data-gate'))this.state.gate=button.dataset.gate;
          if(button.hasAttribute('data-reset'))this.state={shot:this.state.shot,look:'original',film:false,gate:'none'};
          this.update();
        }); this.update();
      }
      expand(){
        this.returnFocus=this.querySelector('[data-expand]');
        this.savedOverflow=document.body.style.overflow;
        this.anchor=document.createComment('eyre-look-position');this.before(this.anchor);
        document.body.append(this);document.body.style.overflow='hidden';
        this.classList.add('is-expanded');this.setAttribute('role','dialog');this.setAttribute('aria-modal','true');this.setAttribute('aria-label','See the film look in action');
        this.querySelector('[data-close]').hidden=false;this.querySelector('[data-expand]').hidden=true;
        this.onModalKey=event=>{
          if(event.key==='Escape'){event.preventDefault();this.collapse();}
          if(event.key==='Tab'){
            const buttons=[...this.querySelectorAll('button')].filter(b=>!b.hidden&&b.getClientRects().length);
            const first=buttons[0],last=buttons[buttons.length-1];
            if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
            else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
          }
        };
        this.addEventListener('keydown',this.onModalKey);this.querySelector('[data-close]').focus();
      }
      collapse(){
        this.classList.remove('is-expanded');this.removeAttribute('role');this.removeAttribute('aria-modal');this.removeAttribute('aria-label');
        this.querySelector('[data-close]').hidden=true;this.querySelector('[data-expand]').hidden=false;
        this.anchor.replaceWith(this);document.body.style.overflow=this.savedOverflow;
        this.removeEventListener('keydown',this.onModalKey);this.returnFocus.focus();
      }
      preloadShots(){
        clearTimeout(this.preloadTimer);
        const {look,film,gate}=this.state;
        const signature=[look,film,gate].join('|');
        this.preloadTimer=setTimeout(async()=>{
          for(let shot=0;shot<6;shot++){
            if([this.state.look,this.state.film,this.state.gate].join('|')!==signature)return;
            const url=this.renderMap[[shot,look,film?'on':'off',gate].join('|')];
            if(!url||this.renderCache.has(url))continue;
            const pending=new Promise((resolve,reject)=>{const asset=new Image();asset.onload=async()=>{try{await asset.decode();resolve(asset);}catch(error){reject(error);}};asset.onerror=()=>reject(new Error('Image unavailable'));asset.src=url;});
            this.renderCache.set(url,pending);
            try{await pending;}catch(error){this.renderCache.delete(url);}
          }
        },150);
      }
      async updateRender(){
        const {shot,look,film,gate}=this.state;
        const key=[shot,look,film?'on':'off',gate].join('|');
        const url=this.renderMap[key];
        const request=++this.renderRequest;
        this.querySelectorAll('[data-shot]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.shot)===shot)));
        this.querySelectorAll('[data-look]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.look===look)));
        this.querySelectorAll('[data-film]').forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.film==='on')===film)));
        this.querySelectorAll('[data-gate]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gate===gate)));
        const label=this.querySelector('[data-look][aria-pressed=true]').textContent.trim();
        const description=label+' · Film Look '+(film?'on':'off')+' · '+({none:'No gate',curved:'35mm Curved',square:'35mm Square',super16:'Super 16'})[gate]+' · Image '+(shot+1);
        const status=this.querySelector('[data-selection]');
        const img=this.querySelector('[data-look-render]');
        const frame=this.querySelector('.eyre-lab__frame');
        this.querySelector('.eyre-lab__notice').textContent='';
        if(!url){frame.setAttribute('aria-busy','false');status.textContent='This combination is not available yet.';return;}
        status.textContent='Loading '+description+'…';frame.setAttribute('aria-busy','true');
        try{
          if(!this.renderCache.has(url)){
            const pending=new Promise((resolve,reject)=>{const asset=new Image();asset.onload=async()=>{try{await asset.decode();resolve(asset);}catch(error){reject(error);}};asset.onerror=()=>reject(new Error('Image unavailable'));asset.src=url;});
            this.renderCache.set(url,pending);
          }
          await this.renderCache.get(url);
          if(request!==this.renderRequest)return;
          img.src=url;img.alt=description;img.hidden=false;frame.setAttribute('aria-busy','false');status.textContent=description;this.preloadShots();
        }catch(error){
          this.renderCache.delete(url);
          if(request!==this.renderRequest)return;
          frame.setAttribute('aria-busy','false');status.textContent='Image could not load. Select the look again to retry.';
        }
      }

      update(){
        if(this.renderMap){this.updateRender();return;}
        this.querySelectorAll('[data-shot-frame]').forEach(frame=>frame.hidden=this.state.gate!=='none'||Number(frame.dataset.shotFrame)!==this.state.shot);
        this.querySelectorAll('[data-shot]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.shot)===this.state.shot)));
        this.querySelectorAll('[data-look]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.look===this.state.look)));
        this.querySelectorAll('[data-film]').forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.film==='on')===this.state.film)));
        this.querySelectorAll('[data-gate]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.gate===this.state.gate)));
        this.querySelectorAll('[data-gate-image]').forEach(img=>img.hidden=img.dataset.gateImage!==this.state.gate);
        const selected=this.querySelector('[data-look][aria-pressed=true]');
        const labels=[selected?selected.textContent:this.copy.original];
        if(this.state.film)labels.push(this.copy.film);if(this.state.gate!=='none')labels.push(({curved:'35mm Curved',square:'35mm Square',super16:'Super 16'})[this.state.gate]);
        this.querySelector('[data-selection]').textContent=this.state.gate!=='none'?({curved:'35mm Curved',square:'35mm Square',super16:'Super 16'})[this.state.gate]+' · supplied gate sample':labels.join(' + ')+(this.state.look!=='original'||this.state.film?' · '+this.copy.pending:'');
        this.querySelector('.eyre-lab__notice').textContent=this.state.gate!=='none'?'Gate preview uses your supplied image. LUT and Film Look combinations are not shown yet.':'Design preview: LUT and Film Look exports are still needed. Gate buttons show the supplied gate samples.';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eyre-mavic-demo"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('eyre-mavic-demo'))customElements.define('eyre-mavic-demo',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.shot=1;this.film='on';this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-shot'))this.shot=Number(b.dataset.shot);else if(b.hasAttribute('data-film'))this.film=b.dataset.film;else if(b.hasAttribute('data-reset')){this.shot=1;this.film='on';}else return;this.querySelectorAll('[data-shot]').forEach(t=>t.setAttribute('aria-pressed',Number(t.dataset.shot)===this.shot));this.querySelectorAll('[data-film]').forEach(t=>t.setAttribute('aria-pressed',t.dataset.film===this.film));this.querySelector('[data-selection]').textContent=this.dataset[this.film].replace('[number]',this.shot);const shot=this.querySelector('[data-shot="'+this.shot+'"]');const img=this.querySelector('[data-main-image]');img.src=this.film==='on'?shot.dataset.onSrc:shot.dataset.offSrc;img.alt='DJI Mavic 4 Pro '+(this.film==='on'?'graded':'Log')+' example '+this.shot;});}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eyre-powergrade-demo"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('eyre-powergrade-demo'))customElements.define('eyre-powergrade-demo',class extends HTMLElement{
 connectedCallback(){
 if(this.ready)return;this.ready=true;this.shot=0;this.film='on';this.request=0;
 this.pairs=JSON.parse(this.querySelector('[data-pairs]').textContent);
 this.addEventListener('click',event=>{const b=event.target.closest('button');if(!b)return;
 if(b.hasAttribute('data-shot'))this.shot=Number(b.dataset.shot);
 else if(b.hasAttribute('data-film'))this.film=b.dataset.film;
 else if(b.hasAttribute('data-reset')){this.shot=0;this.film='on';}else return;
 this.update();});
 }
 async update(){
 const token=++this.request;const url=this.pairs[this.shot][this.film];const img=this.querySelector('[data-render]');const status=this.querySelector('[data-selection]');
 this.querySelectorAll('[data-shot]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.shot)===this.shot)));
 this.querySelectorAll('[data-film]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.film===this.film)));
 const label=this.film==='off'?'Log footage':'Film Emulation PowerGrade shown with an Eyre Cine LUT applied. LUTs sold separately or included in the Pro Bundle.';
 status.textContent='Loading '+label;img.style.opacity='.5';
 const next=new Image();next.src=url;
 try{await next.decode();if(token!==this.request)return;img.src=url;img.alt=label;status.textContent=label;}
 catch(e){if(token!==this.request)return;status.textContent='Image could not load. Please try again.';}
 if(token===this.request)img.style.opacity='1';
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eyre-product-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eyre-product-comparison')) {
    customElements.define('eyre-product-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const range = this.querySelector('input');
        if (!range) return;
        range.value = Number.isFinite(parseFloat(this.style.getPropertyValue('--eyre-split'))) ? parseFloat(this.style.getPropertyValue('--eyre-split')) : 50;
        this.dataset.ready = 'true';
        range.addEventListener('input', () => this.style.setProperty('--eyre-split', `${range.value}%`));
        range.addEventListener('keydown', event => event.stopPropagation());
        this.querySelector('.eyre-comparison__expand')?.addEventListener('click', event => {
          event.stopPropagation();
          const button = event.currentTarget;
          const dialog = document.createElement('dialog');
          dialog.className = 'eyre-comparison__dialog';
          dialog.setAttribute('aria-label', button.dataset.dialogLabel);
          const frame = document.createElement('div');
          frame.className = 'media';
          const comparison = this.cloneNode(true);
          comparison.removeAttribute('data-ready');
          comparison.querySelector('.eyre-comparison__expand').remove();
          const input = comparison.querySelector('input');
          input.id += '-expanded';
          input.value = range.value;
          comparison.querySelector('label').htmlFor = input.id;
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'eyre-comparison__close';
          close.textContent = button.dataset.closeLabel;
          close.addEventListener('click', () => dialog.close());
          frame.append(comparison);
          dialog.append(frame, close);
          dialog.addEventListener('close', () => { dialog.remove(); button.focus(); }, { once: true });
          this.append(dialog);
          dialog.showModal();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
